import { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { AGB_URL } from '../../constants/legal';

/**
 * AgbUpdateModal — blockierendes Re-Akzeptanz-Modal (#245, Chunk E).
 *
 * Erscheint, wenn die Major-Version der vom User akzeptierten AGB von
 * CURRENT_AGB_VERSION abweicht (siehe needsAgbReacceptance im AuthContext).
 * Das Modal ist nicht via ESC oder Overlay-Klick schliessbar — der User
 * muss aktiv akzeptieren oder sich abmelden.
 */
const AgbUpdateModal = () => {
  const { acceptAgb, logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleAccept = async () => {
    setLoading(true);
    setError('');
    try {
      await acceptAgb();
    } catch {
      setError('Die Aktualisierung konnte nicht gespeichert werden. Bitte versuche es erneut.');
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    setLoading(true);
    try {
      await logout();
    } catch {
      setLoading(false);
    }
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="agb-update-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
    >
      <div className="w-full max-w-md bg-white rounded-2xl border border-gray-200 p-6">
        <h2
          id="agb-update-title"
          className="text-xl font-bold text-gray-900 mb-3"
        >
          Aktualisierte AGB
        </h2>
        <p className="text-sm text-gray-700 mb-4">
          Wir haben unsere Allgemeinen Geschäftsbedingungen überarbeitet.
          Bitte lies die aktualisierten{' '}
          <a
            href={AGB_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-emerald-700 hover:underline"
          >
            AGB
          </a>
          , bevor du fortfährst. Wenn du nicht zustimmen möchtest, kannst du
          dich abmelden — dein Account und deine Daten bleiben erhalten.
        </p>
        {error && (
          <p role="alert" className="text-xs text-red-600 mb-3">
            {error}
          </p>
        )}
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={handleAccept}
            disabled={loading}
            className="w-full bg-emerald-600 text-white text-sm py-2 rounded-lg hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? 'Wird gespeichert…' : 'Akzeptieren'}
          </button>
          <button
            type="button"
            onClick={handleLogout}
            disabled={loading}
            className="w-full bg-white text-gray-700 text-sm py-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Abmelden
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgbUpdateModal;
